import { type StateCreator } from 'zustand';

export enum AssetModalPanelState {
  OPEN = 'open',
  CLOSED = 'closed',
}

export type AssetModalPanelSlice = {
  bottomPanel: AssetModalPanelState;
  leftPanel: AssetModalPanelState;
  rightPanel: AssetModalPanelState;
  setBottomPanel: (panel: AssetModalPanelState) => void;
  setLeftPanel: (panel: AssetModalPanelState) => void;
  setRightPanel: (panel: AssetModalPanelState) => void;
  resetBottomPanel: () => void;
  resetLeftPanel: () => void;
  resetRightPanel: () => void;
};

export type CreateAssetModalPanelSliceInitialState = Pick<
  Partial<AssetModalPanelSlice>,
  'bottomPanel' | 'leftPanel' | 'rightPanel'
>;

export const INITIAL_ASSET_MODAL_PANEL_STATE = {
  bottomPanel: AssetModalPanelState.CLOSED,
  leftPanel: AssetModalPanelState.CLOSED,
  rightPanel: AssetModalPanelState.CLOSED,
} satisfies CreateAssetModalPanelSliceInitialState;

export type CreateAssetModalPanelSlice = (
  initialState: CreateAssetModalPanelSliceInitialState,
) => StateCreator<AssetModalPanelSlice, [], [], AssetModalPanelSlice>;

export const createAssetModalPanelSlice: CreateAssetModalPanelSlice = (initialState) => (set) => {
  const mergedInitialState = {
    ...INITIAL_ASSET_MODAL_PANEL_STATE,
    ...initialState,
  };

  return {
    ...mergedInitialState,
    resetBottomPanel: () =>
      set({
        bottomPanel: mergedInitialState.bottomPanel,
      }),
    resetLeftPanel: () =>
      set({
        leftPanel: mergedInitialState.leftPanel,
      }),
    resetRightPanel: () =>
      set({
        rightPanel: mergedInitialState.rightPanel,
      }),
    setBottomPanel: (state: AssetModalPanelState) =>
      set({
        bottomPanel: state,
      }),
    setLeftPanel: (state: AssetModalPanelState) =>
      set({
        leftPanel: state,
      }),
    setRightPanel: (state: AssetModalPanelState) =>
      set({
        rightPanel: state,
      }),
  };
};
